import { render, staticRenderFns } from "./activity-response-modal.vue?vue&type=template&id=2b15ffc0&scoped=true&"
import script from "./activity-response-modal.vue?vue&type=script&lang=js&"
export * from "./activity-response-modal.vue?vue&type=script&lang=js&"
import style0 from "./activity-response-modal.vue?vue&type=style&index=0&id=2b15ffc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b15ffc0",
  null
  
)

component.options.__file = "activity-response-modal.vue"
export default component.exports